/*
 * @Author: Teemo Ding
 * @Date: 2021-06-29 16:15:36
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-10-18 15:44:06
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/index.tsx
 */
import React, { useState } from 'react';

import SettingsPage from '@/src/components/SettingsPage';
import { useParams } from 'react-router';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { ChannelType } from 'src/types/common/SalesChannel';
import { settings } from './config';
import {
  fetchSalesChannel,
  getCurrentSalesChannel,
} from '@/src/constrains/SalesChannelHOC/slice';
import { useDispatch, useSelector } from 'react-redux';

const SalesChannelSettings = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const params: any = useParams();
  const d = useDispatch();

  const { uuid: salesChannelUuid }: any = params;

  const salesChannel = useSelector(getCurrentSalesChannel());
  const [salesChannelName, setSalesChannelName] = useState('');
  const [isMini, setIsMini] = useState(false);

  const handleOnFetchSalesChannel = async () => {
    await d(fetchSalesChannel({ salesChannelUuid }));
  };

  React.useEffect(() => {
    const fetchData = async () => {
      await handleOnFetchSalesChannel();
    };

    fetchData();
  }, [salesChannelUuid]);

  React.useEffect(() => {
    if (salesChannel) {
      setSalesChannelName(salesChannel?.name);
      if (salesChannel?.channelType === ChannelType.MiniProgram) {
        setIsMini(true);
      } else {
        setIsMini(false);
      }
    }
  }, [salesChannel]);

  const breadcrumbData = [
    {
      url: '',
      name: getI18n('general.sider.home'),
    },
    {
      url: `/salesChannel/settings/${salesChannelUuid}`,
      name: getI18n('general.sider.salesChannel'),
    },
    {
      url: '',
      name: salesChannelName,
    },
    {
      url: '',
      name: getI18n('general.sider.settings'),
    },
  ];

  return (
    <SettingsPage
      breadcrumbData={breadcrumbData}
      settings={settings(salesChannelUuid, isMini, { getI18n })}
    />
  );
};
export default SalesChannelSettings;
